module.exports = __webpack_public_path__ + "img/logo-color-experis.01bfc512.svg";